import writeXlsxFile from 'write-excel-file/browser';
import { sanitiseFilename } from '@/features/analytics/utils/exportUtils';
import { buildLabelExportSheets, IMAGES_SHEET, TOOLS_SHEET } from './labelExport';
import type { ToolLabelData } from './labelExport';

export function labelExportFilename(date: Date): string {
  return `${sanitiseFilename(`labeling-export-${date.toISOString().slice(0, 10)}`)}.xlsx`;
}

/** Builds the two-sheet workbook and hands it to the browser as a download. */
export async function exportLabelsXlsx(
  data: ToolLabelData[],
  now: Date = new Date()
): Promise<void> {
  const { tools, images } = buildLabelExportSheets(data);
  await writeXlsxFile([
    { data: tools.rows, sheet: TOOLS_SHEET, columns: tools.columns, stickyRowsCount: 1 },
    { data: images.rows, sheet: IMAGES_SHEET, columns: images.columns, stickyRowsCount: 1 },
  ]).toFile(labelExportFilename(now));
}
